// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"364":"ce8baef0","667":"ce8baef0","768":"ce8baef0","924":"ce8baef0"}[chunkId] + ".css";
};